export enum ACCESS_INFO_KEY {
    paywall = 'paywall',
    authLock = 'authLock',
    lockedUntil = 'lockedUntil',
}
